import { render, staticRenderFns } from "./xhs-activity-table.vue?vue&type=template&id=682dc6bb&scoped=true"
import script from "./xhs-activity-table.vue?vue&type=script&lang=js"
export * from "./xhs-activity-table.vue?vue&type=script&lang=js"
import style0 from "./xhs-activity-table.vue?vue&type=style&index=0&id=682dc6bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682dc6bb",
  null
  
)

export default component.exports